import React, { useContext } from 'react';
import AppContext from '../context/Context';
import VisitorsRoutes from '../routes/VisitorsRoutes';

const VisitorsLayout = () => {
    const { isFluid } = useContext(AppContext);

    return  <div className={isFluid ? 'container-fluid' : 'container'}>
                <VisitorsRoutes />
            </div>
}

export default VisitorsLayout;